import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface TrainingFilledSvgProps extends Omit<SvgWrapperProps, 'children'> {}

export const TrainingFilledSvg = ({ ...svgProps }: TrainingFilledSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 1.5C2.61929 1.5 1.5 2.61929 1.5 4V5C1.5 5.27614 1.72386 5.5 2 5.5C2.27614 5.5 2.5 5.27614 2.5 5V4C2.5 3.17157 3.17157 2.5 4 2.5H14C14.8284 2.5 15.5 3.17157 15.5 4V12C15.5 12.8284 14.8284 13.5 14 13.5H13C12.7239 13.5 12.5 13.7239 12.5 14C12.5 14.2761 12.7239 14.5 13 14.5H14C15.3807 14.5 16.5 13.3807 16.5 12V4C16.5 2.61929 15.3807 1.5 14 1.5H4ZM9.7 8.3C9.7 6.4773 8.2227 5 6.4 5C4.5773 5 3.1 6.4773 3.1 8.3C3.1 9.323 3.5752 10.2239 4.3045 10.83C2.9504 11.4273 2 12.777 2 14.35V15.45C2 15.7536 2.2464 16 2.55 16H10.25C10.5536 16 10.8 15.7536 10.8 15.45V14.35C10.8 12.777 9.8496 11.4273 8.4955 10.83C9.2248 10.2239 9.7 9.323 9.7 8.3ZM3.1 14.35C3.1 12.8331 4.3342 11.6 5.85 11.6H6.95C8.4658 11.6 9.7 12.8331 9.7 14.35V14.9H3.1V14.35ZM4.2 8.3C4.2 7.0867 5.1867 6.1 6.4 6.1C7.6133 6.1 8.6 7.0867 8.6 8.3C8.6 9.5133 7.6133 10.5 6.4 10.5C5.1867 10.5 4.2 9.5133 4.2 8.3Z"
    />
  </SvgWrapper>
);
